import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup
} from '@mui/material'
import { AmlQuestion } from 'api/compliance'
import { useFormikContext } from 'formik'
import { FormValues } from '../OnboardingWizard'
import { commentsRequired } from './amlOptionUtils'
import CommentFormField from './CommentFormField'

interface SingleSelectQuestionProps {
  question: AmlQuestion
}

// Radio group bound to the REST answer_options — the value submitted is the
// canonical option text so the backend matcher resolves it exactly.
export default function SingleSelectQuestion({
  question
}: SingleSelectQuestionProps) {
  const { values, errors, setFieldValue, isSubmitting } =
    useFormikContext<FormValues>()

  const value = String(values[question.key] ?? '')
  const error = errors[question.key]

  return (
    <FormControl component='fieldset' error={!!error} fullWidth>
      <RadioGroup
        aria-label={question.label}
        name={question.key}
        value={value}
        onChange={(_, selected) => setFieldValue(question.key, selected)}
      >
        {(question.answer_options ?? []).map(option => (
          <FormControlLabel
            key={option.answer}
            value={option.answer}
            control={<Radio disabled={isSubmitting} />}
            label={option.answer}
            sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
          />
        ))}
      </RadioGroup>
      {commentsRequired(question, value) && (
        <CommentFormField questionKey={question.key} />
      )}
      {error && <FormHelperText>{String(error)}</FormHelperText>}
    </FormControl>
  )
}
